import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiSearch } from 'react-icons/fi';

export const TD = ({ children, left = false, uppercase = false, bold = false, color }) => (
  <td style={{
    fontSize: 13,
    padding: '11px 16px',
    textAlign: left ? 'left' : 'center',
    borderBottom: '1px solid #f1f5f9',
    color: color || '#374151',
    textTransform: uppercase ? 'uppercase' : undefined,
    fontWeight: bold ? 600 : undefined,
    whiteSpace: 'nowrap',
  }}>
    {children}
  </td>
);

export const inputSx = {
  height: 34,
  padding: '0 10px',
  border: '1px solid #d1d5db',
  borderRadius: 4,
  fontSize: 13,
  fontFamily: 'inherit',
  color: '#111827',
  backgroundColor: '#fff',
  outline: 'none',
  transition: 'border-color 0.15s',
};

export const selectSx = {
  ...inputSx,
  cursor: 'pointer',
};

export default function TableLayout({
  title,
  icon,
  count,
  columns,
  children,
  toolbar,
  search,
  pagination,
  fab,
  emptyMessage,
}) {
  const navigate = useNavigate();

  return (
    <div style={{ padding: '24px 28px 80px', background: '#f9fafb', minHeight: '100%' }}>

      {/* ── Page header ── */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 18 }}>
        {typeof count === 'number' && (
          <span style={{ fontSize: 12, color: '#9ca3af' }}>
            {count} registro{count !== 1 ? 's' : ''}
          </span>
        )}

        {fab?.show && (
          <button
            onClick={() => navigate(`/${fab.path}`)}
            style={{
              display: 'flex', alignItems: 'center', gap: 5,
              height: 32, padding: '0 12px',
              background: '#3b82f6', color: '#fff',
              border: 'none', borderRadius: 4,
              fontSize: 13, fontWeight: 500, cursor: 'pointer',
              transition: 'background 0.15s',
              fontFamily: 'inherit',
            }}
            onMouseEnter={e => e.currentTarget.style.background = '#2563eb'}
            onMouseLeave={e => e.currentTarget.style.background = '#3b82f6'}
          >
            Novo {fab.label}
          </button>
        )}
      </div>

      {/* ── Toolbar ── */}
      {(search || toolbar || pagination) && (
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 8,
          alignItems: 'center',
          marginBottom: 12,
        }}>
          {search && (
            <div style={{ position: 'relative', flex: '1 1 200px', minWidth: 160, display: 'flex' }}>
              <input
                type="text"
                placeholder={search.placeholder || 'Pesquisar...'}
                value={search.value}
                onChange={e => search.onChange(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && search.onSubmit?.()}
                style={{ ...inputSx, width: '100%', boxSizing: 'border-box', paddingRight: search.onSubmit ? 36 : 10 }}
                onFocus={e => e.target.style.borderColor = '#6b7280'}
                onBlur={e => e.target.style.borderColor = '#d1d5db'}
              />
              {search.onSubmit && (
                <button
                  onClick={search.onSubmit}
                  style={{
                    position: 'absolute', right: 1, top: 1, bottom: 1, width: 32,
                    border: 'none', borderLeft: '1px solid #e5e7eb',
                    background: '#f9fafb', cursor: 'pointer', color: '#9ca3af',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    borderRadius: '0 3px 3px 0', transition: 'background 0.15s, color 0.15s',
                  }}
                  onMouseEnter={e => { e.currentTarget.style.background = '#f3f4f6'; e.currentTarget.style.color = '#374151'; }}
                  onMouseLeave={e => { e.currentTarget.style.background = '#f9fafb'; e.currentTarget.style.color = '#9ca3af'; }}
                >
                  <FiSearch size={14} />
                </button>
              )}
            </div>
          )}
          {toolbar}
          {pagination && (
            <select
              value={pagination.value}
              onChange={e => pagination.onChange(Number(e.target.value))}
              style={selectSx}
            >
              {[10, 25, 50, 100].map(n => (
                <option key={n} value={n}>{n} por página</option>
              ))}
            </select>
          )}
        </div>
      )}

      {/* ── Table ── */}
      <div style={{
        background: '#fff',
        border: '1px solid #e5e7eb',
        borderRadius: 6,
        overflow: 'hidden',
      }}>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#f9fafb', borderBottom: '1px solid #e5e7eb' }}>
                {columns.map(col => (
                  <th key={col} style={{
                    padding: '9px 16px',
                    textAlign: 'center',
                    fontSize: 11,
                    fontWeight: 600,
                    color: '#6b7280',
                    letterSpacing: '0.05em',
                    textTransform: 'uppercase',
                    whiteSpace: 'nowrap',
                  }}>
                    {col}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {count === 0 ? (
                <tr>
                  <td colSpan={columns.length} style={{
                    textAlign: 'center', padding: '52px 0',
                    color: '#9ca3af', fontSize: 13.5,
                  }}>
                    {emptyMessage || 'Nenhum registro encontrado.'}
                  </td>
                </tr>
              ) : children}
            </tbody>
          </table>
        </div>
      </div>

    </div>
  );
}
